import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import it from "./locales/it.json";
import en from "./locales/en.json";

// Supported languages for the human-translation phase.
// Italian is the default, English is the secondary language.
export const SUPPORTED_LANGS = [
  { code: "it", label: "Italiano", country: "it" },
  { code: "en", label: "English", country: "gb" },
];

const STORAGE_KEY = "tde_lang";
const initial =
  (typeof window !== "undefined" && window.localStorage.getItem(STORAGE_KEY)) ||
  "it";

i18n.use(initReactI18next).init({
  resources: {
    it: { translation: it },
    en: { translation: en },
  },
  lng: initial,
  fallbackLng: "it",
  interpolation: { escapeValue: false },
  returnEmptyString: false,
});

i18n.on("languageChanged", (lng) => {
  try {
    window.localStorage.setItem(STORAGE_KEY, lng);
    document.documentElement.setAttribute("lang", lng);
  } catch (e) {
    /* ignore */
  }
});

if (typeof document !== "undefined") {
  document.documentElement.setAttribute("lang", initial);
}

export default i18n;
